import {
  minus27abgkurcn6u0 as minus,
  plus18eogev54fmsa as plus,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import {
  minus1djrl64vbav3y as minus_0,
  plus20p0vtfmu0596 as plus_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function notNull(_this__u8e3s4, default_0) {
  var tmp = (it) => it == null ? default_0 : it;
  return _this__u8e3s4.lens_drj4fu_k$(tmp, notNull$lambda);
}
function contains(_this__u8e3s4, value) {
  var tmp = (it) => it.contains_aljjnj_k$(value);
  return _this__u8e3s4.lens_u4wb4z_k$(tmp, (items, bool) => bool ? plus(items, value) : minus(items, value));
}
function asDouble(_this__u8e3s4) {
  var tmp = asDouble$lambda;
  return _this__u8e3s4.lens_drj4fu_k$(tmp, asDouble$lambda_0);
}
function nullToBlank(_this__u8e3s4) {
  var tmp = nullToBlank$lambda;
  return _this__u8e3s4.lens_drj4fu_k$(tmp, nullToBlank$lambda_0);
}
function contains_0(_this__u8e3s4, value) {
  var tmp = (it) => it.contains_aljjnj_k$(value);
  return _this__u8e3s4.lens_u4wb4z_k$(tmp, (items, bool) => bool ? plus_0(items, value) : minus_0(items, value));
}
function notNull$lambda(it) {
  return it;
}
function asDouble$lambda(it) {
  return it == null ? null : it;
}
function asDouble$lambda_0(it) {
  return it == null ? null : numberToInt(it);
}
function nullToBlank$lambda(it) {
  return it == null ? '' : it;
}
function nullToBlank$lambda_0(it) {
  // Inline function 'kotlin.takeUnless' call
  var tmp;
  if (!isBlank(it)) {
    tmp = it;
  } else {
    tmp = null;
  }
  return tmp;
}
//region block: exports
export {
  asDouble as asDouble13iw8t97m16nn,
  contains_0 as contains248yk0xx4662o,
  contains as contains3hkd7li7hrfjb,
  notNull as notNull1cr24slx2d4vw,
  nullToBlank as nullToBlank2cwx9yazfqg5v,
};
//endregion

//# sourceMappingURL=commonLenses.mjs.map
